/**
 * “播放全部”专用上限：
 * - 最多添加 PLAY_ALL_MAX 首到播放列表
 * - 多余的直接放弃（不进入播放列表）
 */

export const PLAY_ALL_MAX = 99;

/**
 * @template T
 * @param {T[]} list
 * @param {number} [max]
 * @returns {T[]}
 */
export function limitPlayAll(list, max = PLAY_ALL_MAX) {
  if (!Array.isArray(list)) return [];
  const m = Number(max);
  if (!Number.isFinite(m) || m <= 0) return [];
  if (list.length <= m) return list;
  return list.slice(0, m);
}

